import i18n from "@/i18n";

export default {
    namespaced: true,
    state: {
        open: false,
        configurator: 'powerpack',
        uid: null,
        locale: 'en',
        trigger: 'share-build',
    },
    mutations: {
        setOpen: (state, newValue) => {
            state.open = newValue;
        },
        setTrigger: (state, newValue) => {
            const allowedValues = [
                'share-build',
                'download-schema',
                'download-step',
                'download-manual-english',
                'download-manual-dutch',
            ];

            if (!allowedValues.includes(newValue)) {
                console.warn(`Invalid trigger value: ${newValue}`);
                return;
            }

            state.trigger = newValue;
        },
        setConfigurator: (state, newValue) => {
            const allowedValues = [
                'powerpack',
                'hose',
                'motor',
                'cylinder',
            ];

            if (!allowedValues.includes(newValue)) {
                console.warn(`Invalid configurator value: ${newValue}`);
                return;
            }

            state.configurator = newValue;
        },
        setUid: (state, newValue) => {
            state.uid = newValue;
        },
        setLocale: (state, newValue) => {
            state.locale = newValue;
        },
    },
    actions: {
        open: ({commit}, {trigger, configurator, uid}) => {
            commit('setLocale', i18n.locale);
            commit('setTrigger', trigger);
            commit('setConfigurator', configurator);
            commit('setUid', uid);
            commit('setOpen', true);
        },
    }
};
